import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import urls, { relativeUrl } from '@/constants/urls';

const AdminUserMenu = ({
  allowNewUserGroup,
  allowTokens,
  allowUserGroups,
  allowUsers,
  url,
}) => (
  <>
    {allowNewUserGroup && (
      <Dropdown.Item as="a" href={url} selected={false}>
        <Icon name="plus" className="primary" />
        <FormattedMessage id="usergroups.header.menu.new" />
      </Dropdown.Item>
    )}
    {allowUsers && (
      <Dropdown.Item as="a" href={`#${relativeUrl(urls.USERS)}`} selected={false}>
        <Icon name="users" className="primary" />
        <FormattedMessage id="admin.header.menu.users" />
      </Dropdown.Item>
    )}

    {allowUserGroups && (
      <Dropdown.Item as="a" href={`#${relativeUrl(urls.USER_GROUPS)}`} selected={false}>
        <Icon name="users" className="primary" />
        <FormattedMessage id="admin.header.menu.usergroups" />
      </Dropdown.Item>
    )}
    {allowTokens && (
      <Dropdown.Item as="a" href={`#${relativeUrl(urls.TOKENS)}`} selected={false}>
        <Icon name="code" className="primary" />
        <FormattedMessage id="admin.header.menu.tokens" />
      </Dropdown.Item>
    )}
  </>
);

export default AdminUserMenu;
